module.exports = __webpack_public_path__ + "ptc_momoro_D1.bb143ea4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_D1.jpg
// module id = Y9xr
// module chunks = 0